import { css, cx } from 'emotion';

import {
	lightGrey,
	headingXLarge,
	headingMedium,
	quadrantsStyle,
	mobileMaxWidthBreakpoint,
	desktopMaxWidthBreakpoint,
	tabletPortraitMaxWidthBreakpoint,
} from 'inside-out/global-styles';

export const quadrantsWrapper = quadrantsStyle;

export const innerWrapperStyle = css({
	maxWidth: desktopMaxWidthBreakpoint,
	width: '100%',
	height: '100%',
	margin: '0 auto',
	padding: '0 20px',
	overflowX: 'hidden',
});

export const sectionsStyle = css({
	borderBottom: `1px solid ${lightGrey}`,
});

export const titleStyle = cx(
	headingXLarge,
	css({
		color: '#fff',
		textAlign: 'center',
		marginBottom: '67px',
		[`@media (max-width: ${tabletPortraitMaxWidthBreakpoint}px)`]: {
			lineHeight: '47px',
		},
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '20px',
			lineHeight: '23px',
			width: '286px',
		},
	})
);

export const subTitleStyle = cx(
	headingMedium,
	css({
		[`@media (max-width: ${mobileMaxWidthBreakpoint}px)`]: {
			fontSize: '16px',
			lineHeight: '18px',
		},
	})
);



// WEBPACK FOOTER //
// ./src/page-styles/health-professionals/index.js